import { closeSnackbar as notistackCloseSnackbar } from "notistack";

export const closeSnackbar = () => notistackCloseSnackbar();
